/**@format */

import { api, wrap } from '../../helpers/request';
import { enqueueNotification } from '../app';
import * as types from './actions';
import reducer from './reducer';

export default reducer;

export const getPeopleLists = (
  options = { withUsers: true }
) => async dispatch => {
  // dispatch loading event
  dispatch({
    type: types.LOAD_PEOPLE_LISTS_REQUEST,
  });
  try {
    const { data } = await wrap(
      api.get('/api/contact/v1/people/lists', {
        params: {
          withUsers: options.withUsers,
        },
      })
    );
    dispatch({
      type: types.LOAD_PEOPLE_LISTS_SUCCESS,
      payload: data.data,
    });
    return data.data;
  } catch (error) {
    dispatch({
      type: types.LOAD_PEOPLE_LISTS_ERROR,
      payload: {
        error,
      },
    });
    throw error;
  }
};
export const getPeopleListById = (
  id,
  options = { withUsers: true }
) => async dispatch => {
  dispatch({
    type: types.LOAD_PEOPLE_LIST_REQUEST,
  });
  try {
    const { data } = await wrap(
      api.get(`/api/contact/v1/people/lists/${id}`, {
        params: options,
      })
    );
    const list = data.data;
    dispatch({
      type: types.LOAD_PEOPLE_LIST_SUCCESS,
      payload: { list },
    });
    return list;
  } catch (error) {
    dispatch({
      type: types.LOAD_PEOPLE_LIST_ERROR,
      payload: {
        error,
      },
    });
    throw error;
  }
};
export const openPeopleList = list => {
  return {
    type: types.ADD_PEOPLE_LIST_TO_OPENED_LISTS,
    payload: { list },
  };
};
export const createPeopleList = data => async dispatch => {
  dispatch({
    type: types.CREATE_PEOPLE_LIST_REQUEST,
  });
  try {
    const { data: res } = await api.post('/api/contact/v1/people/lists', data);
    if (res.success) {
      const list = res.data;
      dispatch({
        type: types.CREATE_PEOPLE_LIST_SUCCESS,
        payload: {
          list,
        },
      });
      return list;
    } else {
      const message = res.message || res.data.message;
      dispatch({
        type: types.CREATE_PEOPLE_LIST_SUCCESS,
        payload: {
          error: message,
        },
      });
      dispatch(enqueueNotification(message));
    }
  } catch (error) {
    const message =
      'Something went wrong while creating list. Please try again or contact support';
    dispatch({
      type: types.CREATE_PEOPLE_LIST_ERROR,
      payload: {
        error,
      },
    });
    dispatch(enqueueNotification(message));
  }
};
export const deletePeopleList = id => async dispatch => {
  dispatch({
    type: types.DELETE_PEOPLE_LIST_REQUEST,
    payload: {
      id,
    },
  });
  try {
    await wrap(api.delete(`/api/contact/v1/people/lists/${id}`));
    dispatch({
      type: types.DELETE_PEOPLE_LIST_SUCCESS,
      payload: {
        id,
      },
    });
  } catch (error) {
    const message =
      'Something went wrong while deleting list. Please try again or contact support';
    dispatch({
      type: types.DELETE_PEOPLE_LIST_ERROR,
      payload: {
        error,
        id,
      },
    });
    dispatch(enqueueNotification(message));
  }
};
export const updatePeopleList = (id, data) => async dispatch => {
  dispatch({
    type: types.UPDATE_PEOPLE_LIST_REQUEST,
  });
  try {
    const { data: res } = await wrap(
      api.put(`/api/contact/v1/people/lists/${id}`, data)
    );
    const list = res.data;
    dispatch({
      type: types.UPDATE_PEOPLE_LIST_SUCCESS,
      payload: {
        list,
      },
    });
    return list;
  } catch (error) {
    const message =
      'Something went wrong while updating list. Please try again or contact support';
    dispatch({
      type: types.UPDATE_PEOPLE_LIST_ERROR,
      payload: {
        error,
      },
    });
    dispatch(enqueueNotification(message));
  }
};

/**
 * @param {{contact:string; list: string}[]} data
 */
export const addContactsToPeopleList = data => async dispatch => {
  dispatch({
    type: types.ADD_CONTACT_TO_PEOPLE_LIST_REQUEST,
  });
  try {
    await wrap(api.post(`/api/contact/v1/people/lists/add-contacts`, data));
    // const list = res.data;
    dispatch({
      type: types.ADD_CONTACT_TO_PEOPLE_LIST_SUCCESS,
    });
    // return list;
  } catch (error) {
    const message = 'Something went wrong while adding contacts to list(s)';
    dispatch(enqueueNotification(message));
    dispatch({
      type: types.ADD_CONTACT_TO_PEOPLE_LIST_ERROR,
      payload: {
        error,
      },
    });
  }
};
/**
 * @param {{contact:string; list: string}[]} data
 */
export const removeContactsFromPeopleList = data => async dispatch => {
  dispatch({
    type: types.REMOVE_CONTACT_FROM_PEOPLE_LIST_REQUEST,
    payload: data,
  });
  try {
    await wrap(api.post(`/api/contact/v1/people/lists/remove-contacts`, data));
    dispatch({
      type: types.REMOVE_CONTACT_FROM_PEOPLE_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message = 'Something went wrong while removing contacts from list(s)';
    dispatch(enqueueNotification(message));
    dispatch({
      type: types.REMOVE_CONTACT_FROM_PEOPLE_LIST_ERROR,
      payload: {
        error,
      },
    });
  }
};

/**
 * @param {{user:string; list: string; role: string}[]} data
 */
export const addUsersToPeopleList = data => async dispatch => {
  dispatch({
    type: types.ADD_USER_TO_PEOPLE_LIST_REQUEST,
  });
  try {
    await wrap(api.post(`/api/contact/v1/people/lists/add-users`, data));
    dispatch({
      type: types.ADD_USER_TO_PEOPLE_LIST_SUCCESS,
    });
  } catch (error) {
    const message = 'Something went wrong while adding users to list(s)';
    dispatch(enqueueNotification(message));
    dispatch({
      type: types.ADD_USER_TO_PEOPLE_LIST_ERROR,
      payload: {
        error,
      },
    });
  }
};

/**
 * @param {{user:string; list: string}[]} data
 */
export const removeUsersFromPeopleList = data => async dispatch => {
  dispatch({
    type: types.REMOVE_USER_FROM_PEOPLE_LIST_REQUEST,
  });
  try {
    await wrap(api.post(`/api/contact/v1/people/lists/remove-users`, data));
    dispatch({
      type: types.REMOVE_USER_FROM_PEOPLE_LIST_SUCCESS,
    });
  } catch (error) {
    const message = 'Something went wrong while removing users from list(s)';
    dispatch(enqueueNotification(message));
    dispatch({
      type: types.REMOVE_USER_FROM_PEOPLE_LIST_ERROR,
      payload: {
        error,
      },
    });
  }
};

export const closePeopleList = list => {
  return {
    type: types.REMOVE_PEOPLE_LIST_FROM_OPENED_LISTS,
    payload: { list },
  };
};
export const setActivePeopleList = list => {
  return {
    type: types.SET_ACTIVE_PEOPLE_LIST,
    payload: { list },
  };
};

export const getOrganizationLists = (
  options = { withUsers: true }
) => async dispatch => {
  dispatch({
    type: types.LOAD_ORGANIZATION_LISTS_REQUEST,
  });
  try {
    const { data } = await wrap(
      api.get('/api/contact/v1/organizations/lists', {
        params: {
          withUsers: options.withUsers,
        },
      })
    );
    dispatch({
      type: types.LOAD_ORGANIZATION_LISTS_SUCCESS,
      payload: data.data,
    });
    return data.data;
  } catch (error) {
    dispatch({
      type: types.LOAD_ORGANIZATION_LISTS_ERROR,
      payload: {
        error,
      },
    });
    throw error;
  }
};
export const getOrganizationListById = (
  id,
  options = { withUsers: true }
) => async dispatch => {
  dispatch({
    type: types.LOAD_ORGANIZATION_LIST_REQUEST,
  });
  try {
    const { data } = await wrap(
      api.get(`/api/contact/v1/organizations/lists/${id}`, {
        params: options,
      })
    );
    const list = data.data;
    dispatch({
      type: types.LOAD_ORGANIZATION_LIST_SUCCESS,
      payload: { list },
    });
    return list;
  } catch (error) {
    dispatch({
      type: types.LOAD_ORGANIZATION_LIST_ERROR,
      payload: {
        error,
      },
    });
    throw error;
  }
};

export const createOrganizationList = data => async dispatch => {
  dispatch({
    type: types.CREATE_ORGANIZATION_LIST_REQUEST,
  });
  try {
    const { data: res } = await wrap(
      api.post('/api/contact/v1/organizations/lists', data)
    );
    const list = res.data;
    dispatch({
      type: types.CREATE_ORGANIZATION_LIST_SUCCESS,
      payload: {
        list,
      },
    });
    return list;
  } catch (error) {
    const message =
      'Something went wrong while creating list. Please try again or contact support';
    dispatch({
      type: types.CREATE_ORGANIZATION_LIST_ERROR,
      payload: {
        error,
      },
    });
    dispatch(enqueueNotification(message));
  }
};
export const updateOrganizationList = (id, data) => async dispatch => {
  dispatch({
    type: types.UPDATE_ORGANIZATION_LIST_REQUEST,
  });
  try {
    const { data: res } = await wrap(
      api.put(`/api/contact/v1/organizations/lists/${id}`, data)
    );
    const list = res.data;
    dispatch({
      type: types.UPDATE_ORGANIZATION_LIST_SUCCESS,
      payload: {
        list,
      },
    });
    return list;
  } catch (error) {
    const message =
      'Something went wrong while updating list. Please try again or contact support';
    dispatch({
      type: types.UPDATE_ORGANIZATION_LIST_ERROR,
      payload: {
        error,
      },
    });
    dispatch(enqueueNotification(message));
  }
};

export const deleteOrganizationList = id => async dispatch => {
  dispatch({
    type: types.DELETE_ORGANIZATION_LIST_REQUEST,
    payload: {
      id,
    },
  });
  try {
    await wrap(api.delete(`/api/contact/v1/organizations/lists/${id}`));
    dispatch({
      type: types.DELETE_ORGANIZATION_LIST_SUCCESS,
      payload: {
        id,
      },
    });
  } catch (error) {
    const message =
      'Something went wrong while deleting list. Please try again or contact support';
    dispatch({
      type: types.DELETE_ORGANIZATION_LIST_ERROR,
      payload: {
        error,
        id,
      },
    });
    dispatch(enqueueNotification(message));
  }
};

/**
 * @param {{contact:string; list: string}[]} data
 */
export const addContactsToOrganizationsList = data => async dispatch => {
  dispatch({
    type: types.ADD_CONTACT_TO_ORGANIZATION_LIST_REQUEST,
  });
  try {
    await wrap(
      api.post(`/api/contact/v1/organizations/lists/add-contacts`, data)
    );
    // const list = res.data;
    dispatch({
      type: types.ADD_CONTACT_TO_ORGANIZATION_LIST_SUCCESS,
    });
    // return list;
  } catch (error) {
    const message = 'Something went wrong while adding contacts to list(s)';
    dispatch(enqueueNotification(message));
    dispatch({
      type: types.ADD_CONTACT_TO_ORGANIZATION_LIST_ERROR,
      payload: {
        error,
      },
    });
  }
};

/**
 * @param {{contact:string; list: string}[]} data
 */
export const removeContactsFromOrganizationList = data => async dispatch => {
  dispatch({
    type: types.REMOVE_CONTACT_FROM_ORGANIZATION_LIST_REQUEST,
    payload: data,
  });
  try {
    await wrap(api.post(`/api/contact/v1/people/lists/remove-contacts`, data));
    dispatch({
      type: types.REMOVE_CONTACT_FROM_ORGANIZATION_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message = 'Something went wrong while removing contacts from list(s)';
    dispatch(enqueueNotification(message));
    dispatch({
      type: types.REMOVE_CONTACT_FROM_ORGANIZATION_LIST_ERROR,
      payload: {
        error,
      },
    });
  }
};

/**
 * @param {{user:string; list: string; role: string;}[]} data
 */
export const addUsersToOrganizationList = data => async dispatch => {
  dispatch({
    type: types.ADD_USER_TO_ORGANIZATION_LIST_REQUEST,
  });
  try {
    await wrap(api.post(`/api/contact/v1/organizations/lists/add-users`, data));
    dispatch({
      type: types.ADD_USER_TO_ORGANIZATION_LIST_SUCCESS,
    });
  } catch (error) {
    const message = 'Something went wrong while adding users to list(s)';
    dispatch(enqueueNotification(message));
    dispatch({
      type: types.ADD_USER_TO_ORGANIZATION_LIST_ERROR,
      payload: {
        error,
      },
    });
  }
};

/**
 * @param {{user:string; list: string}[]} data
 */
export const removeUsersFromOrganizationList = data => async dispatch => {
  dispatch({
    type: types.REMOVE_USER_FROM_ORGANIZATION_LIST_REQUEST,
  });
  try {
    await wrap(
      api.post(`/api/contact/v1/organizations/lists/remove-users`, data)
    );
    dispatch({
      type: types.REMOVE_USER_FROM_ORGANIZATION_LIST_SUCCESS,
    });
  } catch (error) {
    const message = 'Something went wrong while removing users from list(s)';
    dispatch(enqueueNotification(message));
    dispatch({
      type: types.REMOVE_USER_FROM_ORGANIZATION_LIST_ERROR,
      payload: {
        error,
      },
    });
  }
};

export const openOrganizationList = list => {
  return {
    type: types.ADD_ORGANIZATIONS_LIST_TO_OPENED_LISTS,
    payload: { list },
  };
};
export const closeOrganizationList = list => {
  return {
    type: types.REMOVE_ORGANIZATIONS_LIST_FROM_OPENED_LISTS,
    payload: { list },
  };
};
export const setActiveOrganizationList = list => ({
  type: types.SET_ACTIVE_ORGANIZATIONS_LIST,
  payload: { list },
});
